import { render, staticRenderFns } from "./sidebar-payments.vue?vue&type=template&id=358c1eea&"
import script from "./sidebar-payments.vue?vue&type=script&lang=js&"
export * from "./sidebar-payments.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-payments.vue?vue&type=style&index=0&id=358c1eea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports